import {
  MAGIC_SUPPORTED_FILE_EXTENSIONS,
  MAGIC_SUPPORTED_IMAGE_ACCEPT,
  MAGIC_SUPPORTED_TEXT_ACCEPT,
} from "../../MagicTypes.js";

export function isMagicSupportedFileExtension(filename: string): boolean {
  const lastDotIndex = filename.lastIndexOf(".");
  const ext =
    lastDotIndex !== -1 ? filename.slice(lastDotIndex).toLowerCase() : "";
  return MAGIC_SUPPORTED_FILE_EXTENSIONS.has(ext);
}

/**
 * Format file extensions from an Accept config object into a human-readable string.
 * Returns uppercase format like "CSV, PDF, and TXT".
 *
 * @param accept - Record mapping MIME types to arrays of extensions (e.g., { "text/csv": [".csv"] })
 * @returns Formatted string like "CSV", "CSV and PDF", or "CSV, PDF, and TXT"
 */
export function formatFileExtensionList(
  accept: Record<string, string[]>,
): string {
  const extensions = [...new Set(Object.values(accept).flat())]
    .map((ext) => ext.replace(".", "").toUpperCase())
    .sort();

  if (extensions.length === 0) {
    return "";
  } else if (extensions.length === 1) {
    return extensions[0]!;
  } else if (extensions.length === 2) {
    return `${extensions[0]} and ${extensions[1]}`;
  }
  return `${extensions.slice(0, -1).join(", ")}, and ${extensions[extensions.length - 1]}`;
}

export const MAGIC_SUPPORTED_IMAGE_EXTENSION_LIST = formatFileExtensionList(
  MAGIC_SUPPORTED_IMAGE_ACCEPT,
);

export const MAGIC_SUPPORTED_TEXT_EXTENSION_LIST = formatFileExtensionList(
  MAGIC_SUPPORTED_TEXT_ACCEPT,
);

function formatAcceptString(accept: Record<string, string[]>): string {
  return [...new Set(Object.values(accept).flat())].join(",");
}

export const MAGIC_SUPPORTED_TEXT_ACCEPT_STRING = formatAcceptString(
  MAGIC_SUPPORTED_TEXT_ACCEPT,
);

export const MAGIC_SUPPORTED_IMAGE_ACCEPT_STRING = formatAcceptString(
  MAGIC_SUPPORTED_IMAGE_ACCEPT,
);

export function isImageFileName(fileName: string): boolean {
  const imageExtensions = Object.values(MAGIC_SUPPORTED_IMAGE_ACCEPT).flat();
  const lowerFileName = fileName.toLowerCase();
  return imageExtensions.some((ext) => lowerFileName.endsWith(ext));
}
